<template>
    <v-tab-item :value="WMDS.value">
        <section class="sub-section">
            <v-container>
                <v-row align="center" class="mb-40 mb-lg-86">
                    <v-col cols="12" lg="6" class="mb-20 mb-lg-0">
                        <div class="w-100 radius-lg bg-grey px-16">
                            <v-img class="d-block mx-auto" max-width="582" src="/images/sub/products/wmds/s1-img1.png"></v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="pl-xl-40">
                            <h3 class="tit--lg font-weight-bold mb-32 mb-lg-58">
                                <!-- 악성코드 유포·경유 <br>
                                웹사이트(홈페이지)란? -->
                                {{ settings.product.wmds.first }}
                            </h3>
                            <p class="page-text-lg color-point font-weight-700 mb-2 mb-lg-8">
                                특징 1
                            </p>
                            <p class="page-text-lg color-grey-57 mb-20 mb-lg-46">
                                이용자가 브라우저로 접속하면 악성코드에 감염될 수 있는 
                                대단히 위험한  웹사이트 입니다.
                            </p>
                            <p class="page-text-lg color-point font-weight-700 mb-2 mb-lg-8">
                                특징 2
                            </p>
                            <p class="page-text-lg color-grey-57 mb-10 mb-lg-20">
                                최근 사회적 문제로 이슈화된 랜섬웨어 같은 악성코드 역시
                                이같은 웹사이트에 접속하는 것만으로 감염됩니다.
                            </p>
                        </div>
                    </v-col>
                </v-row>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    우리 기업의 웹사이트에서 악성코드가 유포·경유되면?
                </h4>
                <v-row class="mx-lg-n44">
                    <v-col cols="12" lg="4" class="px-lg-44 mb-20 mb-lg-0">
                        <div class="process-3dep1 w-100 h-100">
                            <div class="radius-lg bg-grey h-100">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-1.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        웹사이트가 해킹 당하는 순간에는 <br class="d-none d-lg-block">
                                        피해자이지만 악성코드를 <br class="d-none d-lg-block">
                                        <span class="font-weight-bold color-point">유포 • 경유시키는 순간 가해자</span>가 <br class="d-none d-lg-block">
                                        되어버립니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="px-lg-44 mb-20 mb-lg-0">
                        <div class="process-3dep2 w-100 h-100">
                            <div class="radius-lg bg-grey h-100">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-2.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        정보통신망법의 적용 대상인 <br class="d-none d-lg-block">
                                        사업체는 법에서 요구하는 보안 <br class="d-none d-lg-block">
                                        조치가 미흡했다는 이유로 정부 <br class="d-none d-lg-block">
                                        단속 및 <span class="font-weight-bold color-point">과태료 / 과징금 부과대상</span>이 <br class="d-none d-lg-block">
                                        될 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="4" class="px-lg-44">
                        <div class="process-3dep3 w-100 h-100">
                            <div class="radius-lg bg-grey h-100 process-3dep3">
                                <v-img class="d-block w-100" max-width="1024" src="/images/sub/products/wmds/s1-img2-3.png"></v-img>
                                <div class="pa-16 py-md-46">
                                    <p class="page-text-sm color-grey-49 text-center">
                                        악성코드에 감염된 사용자들로부터 <br class="d-none d-lg-block">
                                        <span class="font-weight-bold color-point">집단소송분쟁</span>에 휘말릴 수도 있어 <br class="d-none d-lg-block">
                                        기관 / 기업 이미지에 심각한 <br class="d-none d-lg-block">
                                        타격을 줍니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section bg-grey">
            <v-container>
                <h3 class="tit--lg text-center mb-lg-22">
                    <!-- F1-WMDS <br>
                    Web Malware Detection System란? -->
                    {{ settings.product.wmds.second }}
                </h3>
                <v-img class="d-block mx-auto mb-28 mb-lg-50" max-width="820" src="/images/sub/products/wmds/s2-img1.png"></v-img>

                <div class="bg-white border-light radius-md">
                    <div class="border-bottom border-color-light pa-16 pa-md-0">
                        <v-img class="tb mx-auto" max-width="1200" src="/images/sub/products/wmds/s2-img2.png"></v-img>
                        <v-img class="mo mx-auto" max-width="561" src="/images/sub/products/wmds/s2-img2-mo.png"></v-img>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" class="border-right border-color-light d-flex align-center pa-16 px-md-50 py-lg-20">
                            <v-img class="d-block mr-10 mr-lg-20" max-width="90" src="/images/sub/products/wmds/s2-icon1-1.png"></v-img>
                            <div>
                                <p class="page-text-sm color-grey-49 line-height-12">
                                    <span class="font-weight-bold d-inline-block mb-2 mb-lg-4">공격자(해커)</span> <br>
                                    의도적 공격으로 보안 취약점을 이용한 <br class="d-none d-lg-block">
                                    악성코드 삽입
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center pa-16 px-md-50 py-lg-20">
                            <v-img class="d-block mr-10 mr-lg-20" max-width="90" src="/images/sub/products/wmds/s2-icon1-2.png"></v-img>
                            <div>
                                <p class="page-text-sm color-grey-49 line-height-12">
                                    <span class="font-weight-bold d-inline-block mb-2 mb-lg-4">협력사</span> <br>
                                    비의도적인 공격으로 협력사 등에서 제작한 컨텐츠에 <br class="d-none d-lg-block">
                                    이미 악성코드가 삽입된 상태로 업로드
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- 악성코드 경유·유포 사이트를 통한 <br class="d-none d-lg-block">
                    사고 탐지에 최적화되어 있습니다.  -->
                    {{ settings.product.wmds.third }}
                </h3>

                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    특장점 요약
                </h4>

                <v-row class="mb-40 mb-lg-86">
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                01
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                외부링크 추적
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                외부링크를 인식하고 추적하여 <br class="d-none d-lg-block">
                                유포지까지 경로 추적
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                02
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                최신 DB 패턴 적용
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                악성코드 유포지/경유지 DB 패턴 최신화 제공 <br>
                                (한국인터넷진흥원, 자체분석인력 보유등)
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                03
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                운영 편리성
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                점검대상 웹사이트 Depth와 페이지수 설정 <br class="d-none d-lg-block">
                                가능 등 편리한 운영환경 제공
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                04
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                난독화 처리
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Javascript 난독화 처리 기술을 이용한 <br class="d-none d-lg-block">
                                은닉된 유포코드 탐지
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                05
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                웹 서비스 안정성 유지
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                365X24시간 악성코드 유포 <br class="d-none d-lg-block">
                                삽입 탐지
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="6" lg="4">
                        <div class="radius-sm card pa-16 py-md-50 px-md-34 h-100">
                            <p class="font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18">
                                06
                            </p>
                            <h6 class="page-text-lg font-weight-bold mb-4 mb-lg-10">
                                간편한 등록
                            </h6>
                            <p class="page-text-sm color-grey-49">
                                Non-Agent 로 도메인만 등록하면 <br class="d-none d-lg-block">
                                사용이 가능
                            </p>
                        </div>
                    </v-col>
                </v-row>

                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    주요 대상고객
                </h4>

                <v-row no-gutters class="radius-lg">
                    <v-col cols="12" lg="6" class="pa-16 py-lg-48 bg-img d-lg-flex align-center justify-center" style="background-image: url(/images/sub/products/wmds/s3-img1-1.png);">
                        <div style="w-auto">
                            <h6 class="page-text-lg color-white mb-4 mb-lg-32">
                                방문 고객 보호 및 신뢰성 유지
                            </h6>
                            <p class="page-text-sm color-white font-weight-bold">
                                공공기관
                            </p>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6" class="pa-16 py-lg-48 pl-lg-60 bg-img" style="background-image: url(/images/sub/products/wmds/s3-img1-2.png);">
                        <h6 class="page-text-lg color-gery-57 mb-4 mb-lg-8">
                            보안관제 업체, 웹호스팅 업체, IDC, <br class="d-none d-lg-block">
                            그룹/계열사 보안관리조직, CERT조직 등
                        </h6>
                        <p class="page-text-sm color-point font-weight-bold">
                            대규모 웹사이트 보안관리 조직
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="sub-section bg-grey">
            <v-container>
                <div class="section-title mb-32 mb-lg-56">
                    <h3 class="tit--lg text-center mb-30 mb-lg-44">
                        <!-- F1-WMDS 솔루션 <br>
                        (Web Malware Detection System) -->
                        {{ settings.product.wmds.fourth }}
                    </h3>
                    <p class="page-text-lg color-grey-57 text-center">
                        웹사이트에 멀웨어를 배포하는 코드가 삽입되는지를 주기적으로 검사하고 <br class="d-none d-lg-block">
                        악성코드가 배포되기 전에 미리 탐지하여 <br class="d-none d-lg-block">
                        시스템관리자 또는 관제시스템에 알려 선 조치를 취하기 위한 시스템 입니다.
                    </p>
                </div>
                <div class="s2-box border-light bg-white">
                    <v-row no-gutters>
                        <v-col cols="12" lg="6" class="border-right border-color-light">
                            <p class="py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light">
                                침해사고 탐지/대응강화
                            </p>
                            <div class="pa-16 py-md-24">
                                <p class="color-grey-49 page-text-sm text-center">
                                   신규/변경 되는 웹서비스 Contents에 대한 <br class="d-none d-lg-block">
                                   주기적인 점검으로 사고예방 및 대응
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <p class="py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light">
                                웹서비스 연속성 보장
                            </p>
                            <div class="pa-16 py-md-24">
                                <p class="color-grey-49 page-text-sm text-center">
                                   Non-Agent 구현 및 네트워크 구성에 영향을 <br class="d-none d-lg-block">
                                   주지 않음으로써 웹서비스 연속성 보장
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <p class="w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14 border-top border-bottom border-color-light">
                        웹 기반 악성코드 유포공격 대응 전용 탐지 솔루션
                    </p>
                    <v-row no-gutters>
                        <v-col cols="12" lg="4" class="border-right border-color-light">
                            <div class="bg-grey py-10">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-1.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">편리한 사용</p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4" class="border-right border-color-light">
                            <div class="bg-grey py-10 d-none d-lg-block">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-2.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">웹서버 보안성 강화</p>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="4">
                            <div class="bg-grey py-10 d-none d-lg-block">
                                <v-img class="mx-auto d-block" max-width="48" src="/images/sub/products/ws/arrow-bottom.png"></v-img>
                            </div>
                            <div class="pa-16 py-md-50 border-top border-color-light">
                                <v-img class="mx-auto d-block mb-8 mb-lg-20" max-width="69" src="/images/sub/products/wmds/s4-icon1-3.png"></v-img>
                                <p class="page-text-lg line-height-1 font-weight-bold text-center">간편한 운영</p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
        <section class="sub-section">
            <v-container>
                <h3 class="tit--lg text-center">
                    <!-- 악성코드 경유·유포 사이트를 통한 <br>
                    사고 탐지에 최적화되어 있습니다. -->
                    {{ settings.product.wmds.fifth }}
                </h3>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    WMDS 특장점
                </h4>
                <div class="radius-lg bg-grey mb-40 mb-lg-80 tb">
                     <v-img class="w-100 d-block" max-width="1200" src="/images/sub/products/wmds/s5-img1.png"></v-img>
                </div>
                <div class="mb-40 mo">
                    <v-img class="mx-auto d-block" max-width="400" src="/images/sub/products/wmds/s5-img1-mo.png"></v-img>
                </div>
                <h4 class="line-txt txt-40 font-weight-700 mb-28 mb-lg-40">
                    F1-WMDS 기대효과
                </h4>
                <v-img class="w-100 d-block" max-width="1200" src="/images/sub/products/wmds/s5-img2.png"></v-img>
            </v-container>
        </section>
    </v-tab-item>
</template>

<script>
import { PRIVATE_SALES_TABS } from "@/assets/variables";
const { WMDS } = PRIVATE_SALES_TABS;
import api from "@/api"
export default {
    data() {
        return {
            WMDS,
            settings: null,
            filter: {
                code: "ko"
            }
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            const { settings } = await api.v1.boards.settings.get({
                headers: this.filter
            })
            this.settings = settings[0]
        }
    }
};
</script>

<style scoped>
.process-3dep1, 
.process-3dep2{
    position: relative;
}

.process-3dep1::after, 
.process-3dep2::after{
    content: "";
    display: block;
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 4px solid #f4f7fb;
    background-color: #e4eefc;
    background-image: url(/images/sub/products/wmds/process-arrow.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    top: 50%;
    right: -72px;
    transform: translate(0, -50%);
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .card{
        min-height: 246px;
    }
}
@media (min-width:1200px){
}

</style>
